import React, { useState } from 'react';
import { Button, Select } from '../lib/ui';

/**
 * Site preview: the storefront's home and browse pages side by side in
 * phone-sized iframes, so catalogue edits can be eyeballed without leaving
 * the dashboard. The frames load the real site, so they show exactly what
 * customers see (after any server/CDN caching).
 */

const SOURCES = [
  { key: 'live',  label: 'Live site',             base: 'https://teardrophydro.co.uk' },
  { key: 'local', label: 'Local dev (port 3000)', base: 'http://localhost:3000' },
];

const DEVICES = [
  { key: 'iphone',  label: 'iPhone 14 (390×844)',   w: 390, h: 844 },
  { key: 'small',   label: 'Small phone (360×740)', w: 360, h: 740 },
  { key: 'iphonese', label: 'iPhone SE (375×667)',  w: 375, h: 667 },
  { key: 'tablet',  label: 'Tablet (768×1024)',     w: 768, h: 1024 },
];

const PAGES = [
  { path: '/',                label: 'Front page' },
  { path: '/browse-products', label: 'Browse page' },
];

const label = { fontSize: 11, fontWeight: 700, marginBottom: 4, display: 'block', color: 'var(--muted)' };

function PhoneFrame({ src, title, w, h, reloadKey }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, fontWeight: 700 }}>
        {title}
        <a href={src} target="_blank" rel="noreferrer" style={{ fontSize: 12, fontWeight: 400 }}>open ↗</a>
      </div>
      <div
        style={{
          width: w,
          height: h,
          border: '10px solid #222',
          borderRadius: 28,
          overflow: 'hidden',
          background: '#fff',
          boxShadow: '0 4px 18px rgba(0,0,0,0.15)',
          flex: '0 0 auto',
        }}
      >
        <iframe
          key={reloadKey}
          src={src}
          title={title}
          width={w}
          height={h}
          style={{ border: 0, display: 'block' }}
        />
      </div>
    </div>
  );
}

export default function SitePreviewTab() {
  const [sourceKey, setSourceKey] = useState('live');
  const [deviceKey, setDeviceKey] = useState('iphone');
  const [reloadKey, setReloadKey] = useState(0);

  const source = SOURCES.find(s => s.key === sourceKey) || SOURCES[0];
  const device = DEVICES.find(d => d.key === deviceKey) || DEVICES[0];

  return (
    <div>
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-end', gap: 12, marginBottom: 16 }}>
        <div>
          <span style={label}>Site</span>
          <Select value={sourceKey} onChange={e => setSourceKey(e.target.value)}>
            {SOURCES.map(s => <option key={s.key} value={s.key}>{s.label}</option>)}
          </Select>
        </div>
        <div>
          <span style={label}>Device</span>
          <Select value={deviceKey} onChange={e => setDeviceKey(e.target.value)}>
            {DEVICES.map(d => <option key={d.key} value={d.key}>{d.label}</option>)}
          </Select>
        </div>
        <Button onClick={() => setReloadKey(k => k + 1)}>↻ Reload both</Button>
      </div>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 32, justifyContent: 'center', overflowX: 'auto', paddingBottom: 16 }}>
        {PAGES.map(p => (
          <PhoneFrame
            key={p.path}
            src={source.base + p.path}
            title={p.label}
            w={device.w}
            h={device.h}
            reloadKey={`${reloadKey}-${source.key}`}
          />
        ))}
      </div>
    </div>
  );
}
